<template>
  <div class="dialog-wrap">
    <el-dialog
      :title="dataForm.writing?dataForm.writing.title:''"
      :close-on-click-modal="
      false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      append-to-body
    >
      <el-form
        class="form"
        :model="dataForm"
        :rules="rules"
        ref="dataForm"
        label-width="100px"
        size="mini"
      >
        <el-form-item
          label="账号名称："
          prop="account_id"
        >
          <div class="form-item-text">
            {{
                dataForm.account?dataForm.account.name:"无"
            }}
          </div>
        </el-form-item>
        <el-form-item
          label="选题名称："
          prop="topic_id"
        >
          <div class="form-item-text">
            {{
                dataForm.topic?dataForm.topic.name:"无"
            }}
          </div>

        </el-form-item>
        <el-form-item
          label="文案标题："
          prop="writing_id"
        >
          <div class="form-item-text">
            {{
                dataForm.writing?dataForm.writing.title:"无"
            }}
          </div>
        </el-form-item>
        <el-form-item label="发布时间：">
          <div class="form-item-text">
            {{
                dataForm.writing?$moment(dataForm.writing.pre_pub_time).format("YYYY.MM.DD HH:mm"):""
            }}
          </div>
        </el-form-item>
        <el-form-item
          label="是否首条："
          prop="is_first"
        >
          <el-radio-group
            v-model="dataForm.is_first"
            disabled
          >
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="文案备注：">
          <div class="form-item-text">
            {{
                dataForm.writing&&dataForm.writing.remark?dataForm.writing.remark:"无"
            }}
          </div>
        </el-form-item>
        <el-form-item
          label="发布状态："
          prop="writing_id"
        >
          <el-tag :type="dataForm.status == 1 ? 'success' : 'danger'">{{
                dataForm.status == 1 ? "已发布" : "未发布"
              }}</el-tag>
        </el-form-item>

        <el-form-item
          label="定时："
          prop="is_timer"
        >
          <el-radio-group v-model="dataForm.is_timer">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="定时时间："
          prop="timer_time"
          v-if="dataForm.is_timer==1"
        >
          <el-date-picker
            v-model="dataForm.timer_time"
            type="datetime"
            placeholder="请选择日期时间"
            style="width:100%"
            clearable
            value-format="timestamp"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="发布人："
          prop="publish_user"
        >
          <el-input
            v-model="dataForm.publish_user"
            placeholder="请输入发布人"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input
            v-model="dataForm.remark"
            type="textarea"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <div style="float:left;">
          <el-button @click="handleToOpen()">下 载</el-button>
          <el-button
            type="danger"
            @click="handleToRemove"
            v-if="computePermission('SelecetRelease:Remove')"
          >删除</el-button>
        </div>

        <el-button
          type="primary"
          @click="handleSubmit"
          :disabled="dataForm.status==1"
        >发 布</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>


import { mediapublishUpdate, mediapublishOne, mediapublishstatusUpdate, mediapublishDestroy } from "@/api/select";
import { computePermission } from "@/utils/helper.js";



export default {
  components: {

  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: () => {
        return null
      }
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: {

      },
      rules: {
  /*       account_id: [{ required: true, message: '请选择账号', trigger: 'blur' }],
        topic_id: [{ required: true, message: '请选择选题', trigger: 'blur' }],
        writing_id: [{ required: true, message: '请选择文案', trigger: 'blur' }],
        is_first: [{ required: true, message: '请是否首条', trigger: 'blur' }], */
        timer_time: [{ required: true, message: '请选择定时时间', trigger: 'blur' }],
        publish_user: [{ required: true, message: '请输入发布人', trigger: 'blur' }], 
        is_timer: [{ required: true, message: '请是否定时', trigger: 'blur' }],
      },
      computePermission: computePermission,
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    content(val) {
      if (val) {
        this.fetchDetail()
      }
    }
  },
  methods: {
    fetchDetail() {
      mediapublishOne({ id: this.content.id }).then(res => {
        this.dataForm = res
      })
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let query = {
            id: this.dataForm.id,
            status: 1,
            remark: this.dataForm.remark,
            publish_user: this.dataForm.publish_user,
            is_timer: this.dataForm.is_timer,
            timer_time: this.dataForm.timer_time,
            is_first: this.dataForm.is_first,
          }
          mediapublishstatusUpdate(query).then((res1) => {
            this.$message.success(`修改成功`)
            this.$refs['dataForm'].resetFields()
            this.$emit('submit')
            this.handleClose()
          });
        }
      });
    },

    handleClose() {
      this.$emit('close')
    },
    handleToOpen() {
      if (this.dataForm.writing && this.dataForm.writing.download_url) {
        try {
          let fileData = JSON.parse(this.dataForm.writing.download_url)
          this.getBlob(fileData.url, fileData.name)
        } catch (error) {
          this.getBlob(this.dataForm.writing.download_url)
        }
      }
    },

    getBlob(imgurl, filename = '文件') {
      var ajax = new XMLHttpRequest();
      ajax.open("GET", imgurl, true);
      ajax.responseType = 'blob';
      ajax.onload = e => {
        let res = e.target.response
        let blob = new Blob([res], { type: res.type }) // 这里的res为后端返回的流数据
        if (window.navigator.msSaveOrOpenBlob) { //兼容IE10
          navigator.msSaveBlob(blob, filename)
        } else {
          const href = URL.createObjectURL(blob) //创建新的URL表⽰指定的blob对象
          const a = document.createElement('a') //创建a标签
          a.style.display = 'none'
          a.href = href // 指定下载链接
          a.download = filename //指定下载⽂件名
          a.click() //触发下载
          URL.revokeObjectURL(a.href) //释放URL对象
        }
      }
      ajax.send()
    },
    handleToRemove() {
      this.$confirm("确定要删除此条信息吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        mediapublishDestroy({ id: this.content.id }).then((res) => {
          this.$emit('submit')
          this.handleClose()
        });
      })
    },
    formatePlatform_code(val) {
      const platform_code = {
        1: "小红书",
        2: "公众号",
        3: "微博",
        /*       4: "B站", */
        5: "知乎",
        /*       6: "抖音", */
      };
      return platform_code[val] || "";
    },
    formateType_code(val) {
      const type_code = {
        1: "机构",
        2: "课程",
        3: "学科",
        4: "院校",
      };
      return type_code[val] || "";
    },
  }
}
</script>

<style lang="less" scoped>
/deep/.el-form-item {
  margin-bottom: 10px;
}
</style>
